// La pantalla que pide actualizar la app instalada (candado de versión,
// lib/versionApp.js). Aparece solo cuando el servidor exige una versión mínima
// que este teléfono no tiene, y nunca a mitad de turno: App la decide con
// `debePedirActualizar`, que espera a la próxima apertura sin un turno abierto.
//
// Sin culpa y sin alarma: dice qué pasa, que lo registrado sigue en el
// teléfono y un botón a la tienda. No se puede cerrar, porque la versión vieja
// ya no sirve para lo que viene; por eso el servidor la exige solo cuando la
// tienda ya ofrece la nueva a todos. "Revisar de nuevo" vuelve a preguntar al
// servidor: si Sebastián quitó la exigencia (por ejemplo, porque la tienda
// todavía no la entregaba a todos), la persona vuelve a la app sin reiniciar.
import { useState } from "react";
import Button from "./foundational/Button";
import MarcaMiPAE from "./MarcaMiPAE";
import { URL_TIENDA } from "../lib/versionApp";

const TIENDA = { android: "Google Play", ios: "la App Store" };

export default function ActualizaMiPAE({ plataforma = "android", onAbrirTienda, onRevisar }) {
  const [revisando, setRevisando] = useState(false);
  const url = URL_TIENDA[plataforma] || URL_TIENDA.android;
  const tienda = TIENDA[plataforma] || TIENDA.android;
  const revisar = async () => {
    setRevisando(true);
    try { await onRevisar?.(); } finally { setRevisando(false); }
  };
  const abrir = () => {
    onAbrirTienda?.();
    // En la app instalada, navegar a la tienda la abre fuera de MiPAE.
    window.location.href = url;
  };
  return (
    <main
      className="min-h-screen bg-paper flex flex-col items-center justify-center px-6 text-center"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="actualiza-titulo"
      aria-describedby="actualiza-cuerpo"
    >
      <MarcaMiPAE className="h-10 w-auto" />
      <h1 id="actualiza-titulo" className="mt-6 text-h2 font-semibold text-ink font-sans leading-tight">
        Hay una versión nueva de MiPAE
      </h1>
      <p id="actualiza-cuerpo" className="mt-3 max-w-[340px] text-body text-ink-subtle font-sans leading-relaxed">
        Para seguir usando MiPAE, actualízala desde {tienda}. Lo que tienes guardado sigue aquí.
      </p>
      <Button variant="primary" size="md" className="mt-6 w-full max-w-[320px]" onClick={abrir}>
        Actualizar MiPAE
      </Button>
      {onRevisar && (
        <Button variant="ghost" size="md" className="mt-2 w-full max-w-[320px]" onClick={revisar} disabled={revisando}>
          {revisando ? "Revisando…" : "Revisar de nuevo"}
        </Button>
      )}
    </main>
  );
}
